// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1ST2I","inner":"Form_inner__37qHD","range":"Form_range__25jYK","name":"Form_name__2DXRq","actions":"Form_actions__2fvdz"};